import React, { useEffect, useRef, useState } from "react";
import Layout from '../../../components/layout';
import Header from '../../../components/header';
import Button from '../../../components/elements/button';
import SageMDModalWrapper from "./SageMDModalWrapper";
import { useSagesApi } from '../../../store/api/hooks/sageApiHook';
import toast from 'react-hot-toast';
import { useAppLoader } from '../../../_common/pageLoader/appLoaderHook';
import { showLocalDateTime } from '../../../_common/functions';

const syncItems = [
    { label: 'Sync Account Groups', itm: 'syncAccountGroups' },
    { label: 'Sync Accounts', itm: 'syncAccounts' },
    /* { label: 'Sync Financial Book', itm: 'syncFinancialBook' },
    { label: 'Item GL', itm: 'syncItemGL' }, */
    { label: 'Sync Location', itm: 'syncLocation' },
    { label: 'Sync Department', itm: 'syncDepartment' },
    { label: 'Sync Vendor', itm: 'syncVendor' },
];

const SageMasterDataSync: React.FC = () => {
    const sageApi: any = useSagesApi();
    const SageMDNewModalRef = useRef<any>(null);
    const { showLoader, hideLoader } = useAppLoader();

    const [agrowData, setagrowData] = useState<any>(null);
    const [accrowData, setaccrowData] = useState<any>(null);
    const [fbrowData, setfbrowData] = useState<any>(null);
    const [igrowData, setigrowData] = useState<any>(null);
    const [lrowData, setlrowData] = useState<any>(null);
    const [drowData, setdrowData] = useState<any>(null);
    const [vrowData, setvrowData] = useState<any>(null);
    const [selectedItem, setSelectedItem] = useState<string | null>(null);

    const handleSync = (itm: string) => {
        showLoader();
        const payload = {};

        const callback = (setter: any) => (resp: any) => {
            if (resp.successful) {
                setter(resp);
                toast.success(resp?.message);
            } else {
                toast.error(resp.message || "Connection Failed");
            }
            hideLoader();
        };

        const errorHandler = (error: any) => {
            toast.error(error);
            hideLoader();
        };

        if (itm === 'syncAccountGroups') {
            setagrowData(null);
            sageApi.syncAccountGroups(payload, callback(setagrowData), errorHandler);
        } else if (itm === 'syncAccounts') {
            setaccrowData(null);
            sageApi.syncAccount(payload, callback(setaccrowData), errorHandler);
        } else if (itm === 'syncFinancialBook') {
            setfbrowData(null);
            sageApi.syncFinancialBook(payload, callback(setfbrowData), errorHandler);
        } else if (itm === 'syncItemGL') {
            setigrowData(null);
            sageApi.syncItemGL(payload, callback(setigrowData), errorHandler);
        } else if (itm === 'syncLocation') {
            setlrowData(null);
            sageApi.syncLocation(payload, callback(setlrowData), errorHandler);
        } else if (itm === 'syncDepartment') {
            setdrowData(null);
            sageApi.syncDepartment(payload, callback(setdrowData), errorHandler);
        }
        else if (itm === 'syncVendor') {
            setvrowData(null);
            sageApi.syncVendor(payload, callback(setvrowData), errorHandler);
        }
    };

    const renderSyncInfo = (itm: string) => {
        const dataMap: any = {
            syncAccountGroups: agrowData,
            syncAccounts: accrowData,
            syncFinancialBook: fbrowData,
            syncItemGL: igrowData,
            syncLocation: lrowData,
            syncDepartment: drowData,
            syncVendor: vrowData,
        };

        const data = dataMap[itm];
        if (!data?.syncCount) return null;

        return (
            <div className="text-sm text-gray-500">
                <div>{data.syncCount} Records Synced</div>
                <div>
                    Last Sync: <span className="font-medium">{data?.addedByName || 'N/A'}</span>, <span>{showLocalDateTime(data?.lastSyncDate)}</span>
                </div>
            </div>
        );
    };

    const GetDefaultDataSync = () => {
        const payload: any = {};

        sageApi.getDefaultDataSync(payload, (resp: any) => {
            const data = resp?.syncDataList?.[0];

            if (data) {
                setaccrowData({
                    syncCount: data.accSyncCount,
                    lastSyncDate: data.accLastSyncDate,
                    addedByName: data.accAddedByName,
                });
                setagrowData({
                    syncCount: data.accGrSyncCount,
                    lastSyncDate: data.accGrLastSyncDate,
                    addedByName: data.accGrAddedByName,
                });
                setfbrowData({
                    syncCount: data.fbSyncCount,
                    lastSyncDate: data.fbLastSyncDate,
                    addedByName: data.fbAddedByName,
                });
                 setigrowData({
                    syncCount: data.glSyncCount,
                    lastSyncDate: data.glLastSyncDate,
                    addedByName: data.glAddedByName,
                });
                setlrowData({
                    syncCount: data.fcSyncCount,
                    lastSyncDate: data.fcLastSyncDate,
                    addedByName: data.fcAddedByName,
                });
                setdrowData({
                    syncCount: data.dptSyncCount,
                    lastSyncDate: data.dptLastSyncDate,
                    addedByName: data.dptAddedByName,
                });
                setvrowData({
                    syncCount: data.venSyncCount,
                    lastSyncDate: data.venLastSyncDate,
                    addedByName: data.venAddedByName,
                });

            }

        }, (error: any) => {
            console.log('error =>', error);
            toast.error(error);
        });
    };


    useEffect(() => {
        GetDefaultDataSync();
    }, []);

    return (
        <Layout>
            <Header title="Sage Master Data Sync" back="/settings" />

            <div className="container mx-auto mt-6 px-4">
                <div className="bg-white shadow rounded-md overflow-hidden">
                    <div className="p-5 border-b">
                        <h2 className="text-lg font-semibold text-gray-800">Sync Master Data</h2>
                    </div>

                    {syncItems.map((item, index) => (
                        <div
                            key={index}
                            className="grid md:grid-cols-5 gap-4 border-t p-5 items-start"
                        >
                            <div className="text-gray-600 font-medium">{item.label}</div>

                            <div>
                                <Button
                                    type="button"
                                    className="w-full bg-success text-white flex items-center justify-center"
                                    onClick={() => handleSync(item.itm)}
                                >
                                    Click Here
                                </Button>
                            </div>

                            <div className="md:col-span-2">{renderSyncInfo(item.itm)}</div>

                            <div className="text-right">
                                <Button
                                    type="button"
                                    theme="secondary"
                                    onClick={() => {
                                        setSelectedItem(item.itm);
                                        SageMDNewModalRef.current?.show();
                                    }}
                                >
                                    Show Log
                                </Button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Modal rendered once */}
            <SageMDModalWrapper ref={SageMDNewModalRef} item={selectedItem} />
        </Layout>
    );
};

export default SageMasterDataSync;
